import { Link } from '@tanstack/react-router';
import { ArrowButton } from 'components/ArrowButton/ArrowButton';
import Button from 'components/Button/Button';
import { Modal } from 'components/Modal/Modal';
import { useFunctionalCurrency, useProducts } from 'hooks/products/useProducts';
import useAppLanguage from 'hooks/useAppLanguage';
import usePageConfig from 'hooks/usePageConfig';
import { MouseEventHandler } from 'react';
import appHelpers from 'utils/app-urls';
import messages from './messages';

const cdnURL = appHelpers.getCDNUrl();
const imgDisableEmail = `${cdnURL}assets/components/modal/exclamation.svg`;

interface LinkType {
  path: string;
  name: string;
  onClick?: MouseEventHandler<HTMLAnchorElement> | undefined;
}

export default function ProfileNavigation({
  showDisabledEmailModal,
  toggleDisabledEmailModal,
  hasPassword,
}: {
  showDisabledEmailModal?: boolean;
  toggleDisabledEmailModal?: () => void;
  hasPassword?: boolean;
}) {
  const language = useAppLanguage();
  const { products } = useProducts();
  const { functionalCurrency } = useFunctionalCurrency();

  const withdrawableCryptoProducts = products
    ?.filter(p => p.isWithdrawable && p.type?.toLocaleUpperCase() !== 'FIAT')
    ?.sort((a, b) => (a.code > b.code ? 1 : -1));

  const { profileNavigationMessages } = messages[language];


  const cryptoAccounts = withdrawableCryptoProducts?.map(p => ({
    path: `/funds/withdraw/crypto/${p.code}/disclaimer/acknowledge`,
    name: profileNavigationMessages.cryptoWithdrawlAddress(p.name),
  }));

  const fiatAccount = {
    path: `/funds/withdraw/fiat/${functionalCurrency?.code}/bank-details/edit`,
    name: profileNavigationMessages.bankingDetails,
  };
  const getLinks = (): LinkType[] => {
    if (hasPassword) {
      return [
        {
          path: '/recurring-buys',
          name: profileNavigationMessages.recurringBuys,
        },
        fiatAccount,
        ...(cryptoAccounts ?? []),
        {
          path: '/settings/update-password',
          name: profileNavigationMessages.changePassword,
        },
        {
          path: `/settings/login-method`,
          name: profileNavigationMessages.loginMethod,
        },
      ];
    }
    return [
      {
        path: '/recurring-buys',
        name: profileNavigationMessages.recurringBuys,
      },
      fiatAccount,
      ...(cryptoAccounts ?? []),
      {
        path: '#',
        name: profileNavigationMessages.updateEmailAddress,
        onClick: () => {
          if (toggleDisabledEmailModal) toggleDisabledEmailModal();
        },
      },
      {
        path: `/settings/login-method`,
        name: profileNavigationMessages.loginMethod,
      },
    ];
  };

  return (
    <>
      <div className="flex flex-col">
        <h1 className="font-semibold text-2.5x1 mb-2">
          {profileNavigationMessages.header}
        </h1>
        {getLinks().map((link: LinkType) => {
          return (
            <Link key={link.name} to={link.path} onClick={link.onClick}>
              <div className="bg-background flex mb-2 p-4 py-1 rounded-lg text-header-text text-left">
                <div className="flex h-12 items-center w-1/2">{link.name}</div>
                <div className="flex flex-col h-12 justify-center w-1/2">
                  <ArrowButton className="self-end" />
                </div>
              </div>
            </Link>
          );
        })}
      </div>

    </>
  );
}
